export default __webpack_public_path__ + "static/media/ZA.4d355ef5.svg";